import { render, staticRenderFns } from "./advertPost.vue?vue&type=template&id=750013a2&scoped=true"
import script from "./advertPost.vue?vue&type=script&lang=js"
export * from "./advertPost.vue?vue&type=script&lang=js"
import style0 from "./advertPost.vue?vue&type=style&index=0&id=750013a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750013a2",
  null
  
)

export default component.exports